import './styles.scss'

import React from 'react'
import PropTypes from 'prop-types'

const CheckboxSvg = ({ checked, onChange, height, width, dataAttr, style, labelStyle, isSubmitting, children }) => (
  <span
    style={style}
    className={`checkbox-container${checked ? ' checked' : ''}${isSubmitting ? ' is-submitting' : ''}`}
    onClick={onChange}
    data-attr={dataAttr}
  >
    {checked ? (
      <span className='super-icon checked'>
        <svg
          viewBox='12 10 31 31'
          fill='currentColor'
          fillOpacity='0'
          stroke='currentColor'
          strokeWidth='3'
          focusable='false'
          aria-hidden='true'
          role='presentation'
          strokeLinecap='round'
          strokeLinejoin='round'
          style={{ height: height || 20, width: width || 20 }}
        >
          <path d='m19.1 25.2 4.7 6.2 12.1-11.2' />
        </svg>
      </span>
    ) : (
      <span className='super-icon unchecked' />
    )}

    <label className='checkbox clearfix' style={labelStyle}>
      <span className='super-label'>{children}</span>
    </label>
  </span>
)

CheckboxSvg.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  height: PropTypes.string,
  width: PropTypes.string,
  dataAttr: PropTypes.string,
  style: PropTypes.object,
  labelStyle: PropTypes.object,
  isSubmitting: PropTypes.bool,
  children: PropTypes.node
}

export default CheckboxSvg
